import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
import Skeleton from '@ynap/skeleton';

const bem = new BEMHelper('LineItemSkeleton');

const propTypes = {
    className: PropTypes.string
};

function LineItemSkeleton({ className }) {
    return (
        <li className={bem(null, null, className)}>
            <div>
                <Skeleton className={bem('image')} />
            </div>
            <div>
                <Skeleton className={bem('text')} count={2} align="left" />
            </div>
        </li>
    );
}

LineItemSkeleton.propTypes = propTypes;

export default LineItemSkeleton;
